import { ShiftModel, ShiftSpan } from "@m481/mp-sdk-ng";

import { BaseEntity } from "@mp/common/entities/base.entity";
import { MissionEntity } from "@mp/common/entities/mission.entity";

export interface ShiftEntity extends BaseEntity {
    teamId: string;
    missionId: string;
    mission?: MissionEntity;
    startAt: number;
    missionHourIndex: number;
    assignedUsersIds: Array<string>;
    timespan: ShiftSpan;
}

export class ShiftEntityHelper {
    public static fromModel(shiftModel: ShiftModel): ShiftEntity {
        const startAt = shiftModel.startAt ? new Date(shiftModel.startAt)?.getTime() : new Date().getTime();
        const timespan = shiftModel.timespan || { initialAt: startAt, maxSlots: 1 };

        return {
            id: shiftModel.id,
            missionId: shiftModel.missionId,
            teamId: shiftModel.teamId,
            assignedUsersIds: shiftModel.assignedUsersIds || [],
            mission: undefined,
            isEnabled: shiftModel?.isEnabled ?? true,
            missionHourIndex: shiftModel?.missionHourIndex || 0,
            startAt,
            timespan
        };
    }

    public static toModel(shiftEntity: ShiftEntity): ShiftModel {
        return {
            id: shiftEntity.id,
            missionId: shiftEntity.missionId,
            teamId: shiftEntity.teamId,
            missionHourIndex: shiftEntity.missionHourIndex,
            assignedUsersIds: shiftEntity.assignedUsersIds || [],
            isEnabled: shiftEntity?.isEnabled ?? true,
            timespan: shiftEntity.timespan
        };
    }
}
